import GameData from "../../mobx/GameData";

class _GraphicsPatcher {
    
    async getPatchedGraphicsDataForGame(game) {
        const BaseGame = await import('../../data/BaseGame');
        let tileGraphics = BaseGame.BaseTileGraphics,
            spriteGraphics = BaseGame.BaseSpriteGraphics,
            fontGraphics = BaseGame.BaseFontGraphics;

        const BuiltInTilesets = (await import('../../data/BuiltInTilesets')).default;
        const BuiltInSprites = (await import ('../../data/BuiltInSprites')).default;
        const BuiltInFonts = (await import('../../data/BuiltInFonts')).default;

        const tilesetData = BuiltInTilesets.find(t => t.id === game.builtInTileId).data;
        const spriteData = BuiltInSprites.find(s => s.id === game.builtInSpriteId).data;
        const fontData = BuiltInFonts.find(s => s.id === game.builtInFontId).data;

        for (let i = 0; i < tilesetData.length; i++) {
           tileGraphics[i] = tilesetData[i];
        }
        for (let i = tilesetData.length; i < tileGraphics.length; i++) {
            // Clear out any missing tiles
            tileGraphics[i] = 0;
        }

        for (let i = 0; i < spriteData.length; i++) {
            spriteGraphics[i] = spriteData[i];
        }

        // Sprites are typically 1kb, but we've got 2kb of space to fill. Fill the extra space with blank data
        for (let i = spriteData.length; i < spriteGraphics.length; i++) {
            spriteGraphics[i] = 0;
        }

        for (let i = 0; i < fontData.length; i++) {
            fontGraphics[i] = fontData[i];
        }

        return {tiles: tileGraphics, sprites: spriteGraphics, font: fontGraphics};
    }

    async getPatchedGraphicsDataForGameId(id) {
        return this.patchGraphicsDataForGame(GameData.userGames.find(i => i.id === id));
    }

    async getPatchedGraphicsDataForCurrentGame() {
        return this.patchGraphicsDataForGameId(GameData.currentGame);
    }

    async getPatchedTitleScreenDataForGame(game) {
        let titleData = JSON.parse(JSON.stringify(game.titleScreenData));

        // First patch game name
        let paddedTitle = game.title;
        while (paddedTitle.length < 26) {
            paddedTitle = ' ' + paddedTitle + ' ';
        }
        if (paddedTitle.length > 26) {
            paddedTitle = paddedTitle.slice(0, 26);
        }
        for (let i = 0; i < paddedTitle.length; i++) {
            titleData[0x123 + i] = paddedTitle[i].charCodeAt(0) + 0x60;
        }

        // Next, author
        let paddedCopyline = '      Copyright ' + (new Date()).getFullYear() + '      ';
        let paddedAuthor = game.author;
        while (paddedAuthor.length < 25) {
            paddedAuthor = ' ' + paddedAuthor + ' ';
        }

        for (let i = 0; i < paddedCopyline.length; i++) {
            titleData[0x2a3 + i] = paddedCopyline[i].charCodeAt(0) + 0x60;
        }

        for (let i = 0; i < paddedAuthor.length; i++) {
            titleData[0x2e3 + i] = paddedAuthor[i].charCodeAt(0) + 0x60;
        }

        return titleData;
    }

    creditsLeftX = 4;
    creditsRightX = 28;
    creditsTopYArt = 18;
    creditsBottomYArt = 20;
    creditsTopYMusic = 21;
    creditsBottomYMusic = 23;

    async getPatchedCreditsDataForGame(game) {
        const BuiltInSongs = (await import('../../data/BuiltInSongs')).default;
        const BuiltInTilesets = (await import ('../../data/BuiltInTilesets')).default;
        const BuiltInSprites = (await import ('../../data/BuiltInSprites')).default;
        const graphicsHeader = 'Graphics                ';
        const musicHeader    = 'Music                   ';

        let creditsData = JSON.parse(JSON.stringify(game.creditsScreenData));

        if (game.useBuiltInGraphics) {
            const author1 = ' ' + BuiltInTilesets.find(t => t.id === game.builtInTileId).gameCredit.padEnd(24, ' ');
            const author2 = ' ' + BuiltInSprites.find(t => t.id === game.builtInSpriteId).gameCredit.padEnd(24, ' ');
            let showBoth = true;

            if (author1 === author2) {
                showBoth = false;
            }

            let tilePos = (this.creditsTopYArt * 32) + this.creditsLeftX;
            for (let i = 0; i < graphicsHeader.length; i++) {
                creditsData[tilePos + i] = graphicsHeader.charCodeAt(i) + 0x60;
            }
            tilePos += 32;
            for (let i = 0; i < author1.length; i++) {
                creditsData[tilePos + i] = author1.charCodeAt(i) + 0x60;
            }
            if (showBoth) {
                tilePos += 32;
                for (let i = 0; i < author2.length; i++) {
                    creditsData[tilePos + i] = author2.charCodeAt(i) + 0x60;
                }
    
            } else {
                tilePos += 32;
                for (let i = 0; i < 24; i++) {
                    creditsData[tilePos + i] = ' '.charCodeAt(0) + 0x60;
                }
            }
        }

        if (game.usingBuiltInMusic) {
            const music1 = ' ' + BuiltInSongs.find(t => t.id === game.creditsSong).gameCredit.padEnd(24, ' ');
            const music2 = ' ' + BuiltInSongs.find(t => t.id === game.gameplaySong).gameCredit.padEnd(24, ' ');
            const music3 = ' ' + BuiltInSongs.find(t => t.id === game.creditsSong).gameCredit.padEnd(24, ' ');

            let numDrawn = 0;
            let tilePos = (this.creditsTopYMusic * 32) + this.creditsLeftX;
            for (let i = 0; i < musicHeader.length; i++) {
                creditsData[tilePos + i] = musicHeader.charCodeAt(i) + 0x60;
            }
            tilePos += 32;
            for (let i = 0; i < music1.length; i++) {
                creditsData[tilePos + i] = music1.charCodeAt(i) + 0x60;
            }
            numDrawn++;
            if (music2 !== music1) {
                tilePos += 32;
                for (let i = 0; i < music2.length; i++) {
                    creditsData[tilePos + i] = music2.charCodeAt(i) + 0x60;
                }
                numDrawn++;
            }
            if (music3 !== music1 && music3 !== music2) {
                tilePos += 32;
                for (let i = 0; i < music3.length; i++) {
                    creditsData[tilePos + i] = music3.charCodeAt(i) + 0x60;
                }
                numDrawn++;
            }

            while (numDrawn !== 2) {
                tilePos += 32;
                for (let i = 0; i < 24; i++) {
                    creditsData[tilePos + i] = ' '.charCodeAt(0) + 0x60;
                }
                numDrawn++;
            }
        }
        return creditsData;
    }
}

const GraphicsPatcher = new _GraphicsPatcher();

export default GraphicsPatcher;